export default ($t) => ({
  title: "CustomTabsUnidyClassic",
  type: "object",
  expanded: true,
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
    content: {
      title: $t("edit_campaign.schema_custom_tabs_unidy_classic_content", "Content"),
      type: "list",
      default: [],
      expanded: true,
      items: {
        type: "object",
        properties: {
          component: {
            title: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_component",
              "Type"
            ),
            type: "enum",
            deepUpdate: true,
            default: "",
            description: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_component_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
            items: {
              enum: [
                {
                  text: $t(
                    "edit_campaign.schema_custom_tabs_unidy_classic_content_items_component_items_enum_pdf_viewer",
                    "PDF Viewer"
                  ),
                  value: "pdf_viewer",
                },
                {
                  text: $t(
                    "edit_campaign.schema_custom_tabs_unidy_classic_content_items_component_items_enum_team_list",
                    "Team List"
                  ),
                  value: "team_list",
                },
                {
                  text: $t(
                    "edit_campaign.schema_custom_tabs_unidy_classic_content_items_component_items_enum_taggbox",
                    "Taggbox"
                  ),
                  value: "taggbox",
                },
                {
                  text: $t(
                    "edit_campaign.schema_custom_tabs_unidy_classic_content_items_component_items_enum_donors_custom_fields",
                    "Donors custom fields"
                  ),
                  value: "donors_custom_fields",
                },
                {
                  text: $t(
                    "edit_campaign.schema_custom_tabs_unidy_classic_content_items_component_items_enum_remote_api",
                    "Remote API"
                  ),
                  value: "remote_api",
                },
                {
                  text: $t(
                    "edit_campaign.schema_custom_tabs_unidy_classic_content_items_component_items_enum_content",
                    "Content"
                  ),
                  value: "",
                },
              ],
            },
          },
          key: {
            title: $t("edit_campaign.schema_custom_tabs_unidy_classic_content_items_key", "Key"),
            type: "string",
            default: "",
            placeholder: "custom_component_2",
            description: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_key_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          title: {
            title: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_title",
              "Title"
            ),
            type: "string",
            default: "",
            placeholder: "Pdf viewer",
            description: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_title_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          content: {
            $if(form) {
              return form?.component === "pdf_viewer" || !form?.component || false;
            },
            title: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_content",
              "Content"
            ),
            type: "string",
            default: "",
            placeholder:
              "https://s2.q4cdn.com/175719177/files/doc_presentations/Placeholder-PDF.pdf",
            description: $t(
              "edit_campaign.schema.custom_tabs_unidy_classic.content.items.content_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          wall_id: {
            $if(form) {
              return form?.component === "taggbox" || false;
            },
            title: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_wall_id",
              "Wall ID"
            ),
            type: "string",
            default: "",
            placeholder: "57870",
            description: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_wall_id_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          lang: {
            $if(form) {
              return !form?.component || false;
            },
            title: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_lang",
              "Language"
            ),
            type: "object",
            component: "LanguageSelect",
          },
          settings: {
            title: $t(
              "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings",
              "Settings"
            ),
            type: "object",
            properties: {
              filter_by_team: {
                $if(_, parentForm) {
                  return (
                    parentForm?.component === "donors_custom_fields" ||
                    parentForm?.component === "team_list" ||
                    false
                  );
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_filter_by_team",
                  "Filter by team"
                ),
                type: "boolean",
                default: true,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_filter_by_team_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              parent_teams_only: {
                $if(_, parentForm) {
                  return (
                    parentForm?.component === "donors_custom_fields" ||
                    parentForm?.component === "team_list" ||
                    false
                  );
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_parent_teams_only",
                  "Parent teams only"
                ),
                type: "boolean",
                default: true,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_parent_teams_only_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              granparent_teams_only: {
                $if(_, parentForm) {
                  return (
                    parentForm?.component === "donors_custom_fields" ||
                    parentForm?.component === "team_list" ||
                    false
                  );
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_granparent_teams_only",
                  "Grandparent teams only"
                ),
                type: "boolean",
                default: false,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_granparent_teams_only_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              remote_api_url: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_remote_api_url",
                  "Remote API url"
                ),
                type: "string",
                default:
                  "https://tool.microserviceland.com/service/:service_id/tools/spreadsheetreader/:file_id?max_age=10",
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_remote_api_url_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              remote_api_service_id: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_remote_api_service_id",
                  "Remote API service id"
                ),
                type: "string",
                default: "23233505-d614-2a49-1556-e42b7612e154",
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_remote_api_service_id_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              remote_api_file_id: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_remote_api_file_id",
                  "Remote API file id"
                ),
                type: "string",
                default: "1Vd74H6Azs4se0nH5UZs4RfeGB1VnkV73ity6exoUJBI",
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_remote_api_file_id_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              orders: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_orders",
                  "Enter field names in display order (Lamplighters, Partners... etc.)"
                ),
                type: "array",
                expanded: true,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_orders_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              colors: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_colors",
                  "Colors to be used for sections (HEX codes, 1st color = 1st section, 2nd = 2nd, etc.)"
                ),
                type: "array",
                default: ["#C15B74", "#12B1A0", "#C09B39", "#000000", "#828282"],
                expanded: true,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_colors_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              columns: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_columns",
                  "Columns to be used for sections (1st column = 1st section, 2nd column = 2nd section, etc., comma-separated)"
                ),
                default: "4, 5, 6, 6, 6",
                type: "string",
                expanded: true,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_columns_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              fontSize: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_fontsize",
                  "Font size to be used for sections (number, 1st font size = 1st section, 2nd font size = 2nd section, etc., comma-separated)"
                ),
                type: "string",
                default: "15, 13, 11, 11, 11",
                expanded: true,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_fontsize_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              icons: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_icons",
                  "Icons URLs to be used for sections (1st icon = 1st section, 2nd icon = 2nd section, etc.)"
                ),
                type: "array",
                default: [
                  "https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/public_upload/1746125316_3533333137313764333364346536333466643363356563323039663437356432_31373436313235333136.svg",
                  "https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/public_upload/1746125601_3538323333353862646564636434633261373066663536333533343133306439_31373436313235363031.svg",
                  "https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/public_upload/1746125689_3666303431616634336265383761313935626433663037353932326633343461_31373436313235363839.svg",
                  "https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/public_upload/1746125756_3466626437353363663830653966353866663333373239613832376430623134_31373436313235373536.svg",
                  "https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/public_upload/1746125805_3364353934363134663434356636623030303134653962373737333062383333_31373436313235383035.svg",
                ],
                expanded: true,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_icons_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
              remote_api_show_donor_list: {
                $if(_, parentForm) {
                  return parentForm?.component === "remote_api" || false;
                },
                title: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_remote_api_show_donor_list",
                  "Show donor list"
                ),
                type: "boolean",
                default: false,
                description: $t(
                  "edit_campaign.schema_custom_tabs_unidy_classic_content_items_settings_remote_api_show_donor_list_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
            },
          },
        },
      },
    },
  },
});
